<template>
  <!-- :style="{ width: `${screenWidth}px`, height: `${screenHeight}px` }" -->
  <div id="app">
    <router-view />
  </div>
</template>
 
<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
    };
  },
  created() {},
  mounted() {
    // this.hadleOnsize();
    // window.addEventListener("resize", () => {
    //   this.hadleOnsize();
    // });
  },
  watch: {},
  methods: {
    // hadleOnsize() {
    //   const that = this;
    //   window.screenWidth = document.body.clientWidth;
    //   that.screenWidth = window.screenWidth;
    //   that.screenHeight = $(window).height();
    // },
  },
  computed: {
    key() {
      return this.$router.push({ path: "/" });
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue